let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fGIvQ")).then(() => parcelRequire('h7Z1H'));